/* Leg Down Racing landing page. Runs only on the homepage, inside #ldr-landing. */
(function () {
  if (window.LDRLanding) return;

  var FONTS = 'https://fonts.googleapis.com/css2?family=Barlow:wght@400;500;600&family=Saira:ital,wdth,wght@0,50..125,100..900;1,50..125,100..900&display=swap';
  var html = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var current = null;

  function loadFonts() {
    if (document.getElementById('ldr-landing-fonts')) return;
    var l = document.createElement('link');
    l.id = 'ldr-landing-fonts'; l.rel = 'stylesheet'; l.href = FONTS;
    document.head.appendChild(l);
  }

  function setOpen(open) {
    html.classList.remove('ldr-open', 'ldr-closed');
    html.classList.add(open ? 'ldr-open' : 'ldr-closed');
  }

  function init(root) {
    if (!root || root.__ldr) return;
    root.__ldr = true;
    if (current && current !== root && current.__ldrDestroy) current.__ldrDestroy();
    current = root;

    var editor = root.getAttribute('data-editor') === 'true';
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var formState = !!root.querySelector('.rq-ok, .rq-err');
    var cleanups = [];
    var on = function (target, type, fn, opts) { target.addEventListener(type, fn, opts); cleanups.push(function () { target.removeEventListener(type, fn, opts); }); };

    if (editor) setOpen(root.getAttribute('data-show-in-editor') === 'true');
    if (formState) setOpen(true);
    if (html.classList.contains('ldr-open')) loadFonts();

    /* keep the header clear of the landing page's own scrollbar */
    var sbw = function () { root.style.setProperty('--ldr-sbw', (root.offsetWidth - root.clientWidth) + 'px'); };
    sbw(); on(window, 'resize', sbw);

    /* the store behind stays out of reach while the landing page is open */
    var inerted = [];
    function inertOthers() {
      if (editor || !html.classList.contains('ldr-open')) return;
      Array.prototype.forEach.call(document.body.children, function (el) {
        if (el === root || el.tagName === 'SCRIPT' || el.tagName === 'STYLE' || el.tagName === 'LINK' || el.hasAttribute('inert')) return;
        el.setAttribute('inert', ''); inerted.push(el);
      });
    }
    function releaseOthers() { inerted.forEach(function (el) { el.removeAttribute('inert'); }); inerted = []; }
    inertOthers();
    if (document.readyState === 'loading') on(document, 'DOMContentLoaded', inertOthers);
    on(window, 'load', inertOthers);

    /* ---------- open and close ---------- */
    var closing = false;
    function close(href) {
      if (closing) return;
      if (href) { window.location.href = href; return; }
      closing = true;
      root.classList.add('is-closing');
      releaseOthers();
      setTimeout(function () {
        setOpen(false);
        root.classList.remove('is-closing');
        closing = false;
        window.scrollTo(0, 0);
        var main = Array.prototype.filter.call(document.querySelectorAll('#MainContent, main, [role="main"]'), function (m) { return !root.contains(m); })[0];
        if (main) { if (!main.hasAttribute('tabindex')) main.setAttribute('tabindex', '-1'); main.focus({ preventScroll: true }); }
      }, 520);
    }
    function openLanding() {
      setOpen(true); loadFonts(); root.scrollTop = 0; sbw(); inertOthers();
    }
    root.__ldrOpen = openLanding;

    on(root, 'click', function (e) {
      var closer = e.target.closest('[data-ldr-close]');
      if (closer) { e.preventDefault(); close(root.getAttribute('data-shop-href') || ''); return; }
      var jump = e.target.closest('[data-ldr-jump]');
      if (jump) {
        var target = root.querySelector(jump.getAttribute('href'));
        if (target) { e.preventDefault(); target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }
      }
    });

    /* ---------- intro: LD mark, quick cuts, then the hero ---------- */
    var intro = $('#ldr-intro');
    var cuts = intro ? $$('.intro-cut') : [];
    var timers = [];
    var later = function (fn, ms) { timers.push(setTimeout(fn, ms)); };
    function heroEnter() { root.classList.remove('hero-enter'); void root.offsetWidth; root.classList.add('hero-enter'); }
    function endIntro() {
      if (!intro || intro.hidden) return;
      timers.forEach(clearTimeout); timers = [];
      intro.classList.add('s-out');
      heroEnter();
      setTimeout(function () { intro.hidden = true; intro.className = 'intro'; cuts.forEach(function (c) { c.classList.remove('on'); }); }, 520);
    }
    function playIntro() {
      timers.forEach(clearTimeout); timers = [];
      intro.className = 'intro'; intro.hidden = false; root.scrollTop = 0;
      requestAnimationFrame(function () { intro.classList.add('s-mark'); });
      if (root.getAttribute('data-intro-cuts') !== 'true' || !cuts.length) { later(endIntro, 1600); return; } later(function () { intro.classList.add('s-cuts'); }, 950);
      cuts.forEach(function (c, i) { later(function () { cuts.forEach(function (x) { x.classList.remove('on'); }); c.classList.add('on'); }, 1050 + i * 230); });
      later(endIntro, 1050 + cuts.length * 230 + 120);
    }
    if (intro) {
      on($('#ldr-skip'), 'click', endIntro);
      if (html.classList.contains('ldr-open') && !editor && !reduce && !formState) playIntro();
      else intro.hidden = true;
    }

    /* ---------- mobile menu ---------- */
    var menu = $('#ldr-menu'), menuBtn = $('#ldr-menu-btn');
    function setMenu(open) {
      menu.hidden = !open;
      menuBtn.setAttribute('aria-expanded', String(open));
      menuBtn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      root.style.overflowY = open ? 'hidden' : '';
    }
    on(menuBtn, 'click', function () { setMenu(menu.hidden); });
    on(menu, 'click', function (e) { if (e.target.closest('a')) setMenu(false); });
    on(document, 'keydown', function (e) {
      if (e.key !== 'Escape' || !html.classList.contains('ldr-open')) return;
      if (!menu.hidden) { setMenu(false); menuBtn.focus(); return; }
      if (intro && !intro.hidden && !intro.classList.contains('s-out')) { endIntro(); return; }
      if (!editor) close('');
    });

    /* ---------- statement words light up as you scroll ---------- */
    var stmt = $('#ldr-stmt');
    $$('#ldr-stmt .line').forEach(function (line) {
      line.innerHTML = line.textContent.trim().split(/\s+/).map(function (w) {
        var s = document.createElement('span'); s.className = 'w'; s.textContent = w; return s.outerHTML;
      }).join(' ');
    });
    var words = $$('#ldr-stmt .w');
    if (reduce) words.forEach(function (w) { w.classList.add('lit'); });

    /* ---------- sections settle in as they enter ---------- */
    var io = null;
    if (!reduce && 'IntersectionObserver' in window) {
      io = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
      }, { root: root, threshold: 0.12 });
      $$('.rv').forEach(function (el) { io.observe(el); });
    }

    /* ---------- scroll and pointer loop ---------- */
    var hdr = $('#ldr-hdr'), prog = $('#ldr-prog'), heroMedia = $('#ldr-hero-media'), heroTitle = $('#ldr-hero-title'), giant = $('#ldr-giant');
    var mx = 0, my = 0, tx = 0, ty = 0, raf = 0;
    if (finePointer && !reduce) on(window, 'pointermove', function (e) { tx = e.clientX / window.innerWidth - 0.5; ty = e.clientY / window.innerHeight - 0.5; }, { passive: true });

    function frame() {
      raf = requestAnimationFrame(frame);
      if (!html.classList.contains('ldr-open')) return;
      var y = root.scrollTop, vh = root.clientHeight, vw = window.innerWidth;
      hdr.classList.toggle('scrolled', y > 24);
      var max = root.scrollHeight - vh;
      prog.style.transform = 'scaleX(' + (max > 0 ? y / max : 0) + ')';
      if (reduce) return;
      mx += (tx - mx) * 0.06; my += (ty - my) * 0.06;
      if (vw > 1100 && y < vh * 1.2) {
        heroMedia.style.transform = 'translate3d(' + (-mx * 18) + 'px,' + (y * 0.22 - my * 12) + 'px,0) scale(1.045)';
        heroTitle.style.transform = 'translate3d(' + (mx * 8) + 'px,' + (y * 0.1 + my * 6) + 'px,0)';
      } else if (vw <= 1100) { heroMedia.style.transform = ''; heroTitle.style.transform = ''; }
      if (giant) {
        var sr = giant.parentElement.getBoundingClientRect();
        if (sr.bottom > 0 && sr.top < vh) giant.style.setProperty('--gx', ((sr.top - vh) * 0.35) + 'px');
      }
      if (stmt && words.length) {
        var hr = stmt.getBoundingClientRect();
        var p = clamp((vh * 0.82 - hr.top) / (hr.height + vh * 0.3), 0, 1);
        var n = Math.round(p * words.length * 1.15);
        words.forEach(function (w, i) { w.classList.toggle('lit', i < n); });
      }
    }
    raf = requestAnimationFrame(frame);

    /* ---------- past events: arrow buttons ---------- */
    var evTrack = $('#ldr-ev-track'), evPrev = $('#ldr-ev-prev'), evNext = $('#ldr-ev-next');
    if (evTrack && evPrev && evNext) {
      var evStep = function () { var c = evTrack.querySelector('.ev'); return (c ? c.getBoundingClientRect().width : 300) + 18; };
      var evUpdate = function () {
        evPrev.parentElement.hidden = evTrack.scrollWidth <= evTrack.clientWidth + 4;
        evPrev.disabled = evTrack.scrollLeft < 8;
        evNext.disabled = evTrack.scrollLeft + evTrack.clientWidth > evTrack.scrollWidth - 8;
      };
      on(evPrev, 'click', function () { evTrack.scrollBy({ left: -evStep(), behavior: reduce ? 'auto' : 'smooth' }); });
      on(evNext, 'click', function () { evTrack.scrollBy({ left: evStep(), behavior: reduce ? 'auto' : 'smooth' }); });
      on(evTrack, 'scroll', evUpdate, { passive: true });
      on(window, 'resize', evUpdate);
      evUpdate(); setTimeout(evUpdate, 600);
    }

    /* ---------- custom request form: friendly checks before it sends ---------- */
    var form = $('#ldr-request-form');
    if (form) {
      form.setAttribute('novalidate', '');
      on(form, 'submit', function (e) {
        var reason = form.querySelector('#ldr-rq-reason'), email = form.querySelector('#ldr-rq-email'), st = form.querySelector('#ldr-rq-status');
        var okReason = !reason || !!reason.value, okEmail = /.+@.+\..+/.test(email.value);
        if (reason) reason.setAttribute('aria-invalid', String(!okReason));
        email.setAttribute('aria-invalid', String(!okEmail));
        if (!okReason || !okEmail) {
          e.preventDefault();
          if (st) st.textContent = !okReason ? 'Choose a reason for your request.' : 'Enter a valid email so we can reply.';
          (!okReason ? reason : email).focus();
        } else if (st) { st.textContent = 'Sending…'; }
      });
      if (formState) {
        var go = function () { var c = $('#ldr-contact'); if (c) c.scrollIntoView({ block: 'start' }); };
        go(); setTimeout(go, 400);
      }
    }

    root.__ldrDestroy = function () {
      cancelAnimationFrame(raf);
      timers.forEach(clearTimeout);
      if (io) io.disconnect();
      cleanups.forEach(function (fn) { fn(); });
      releaseOthers();
    };
  }

  /* ---------- theme editor: re-run after a settings change ---------- */
  function adopt(container) {
    var el = container && container.querySelector ? container.querySelector('[data-ldr-landing]') : null;
    if (!el) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-ldr-landing]'), function (x) {
      if (x !== el) { if (x.__ldrDestroy) x.__ldrDestroy(); x.remove(); }
    });
    document.body.appendChild(el);
    init(el);
  }
  document.addEventListener('shopify:section:load', function (e) { adopt(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var id = e.detail && e.detail.sectionId;
    Array.prototype.forEach.call(document.querySelectorAll('[data-ldr-landing]'), function (x) {
      if (x.getAttribute('data-section-id') === id) { if (x.__ldrDestroy) x.__ldrDestroy(); x.remove(); html.classList.remove('ldr-open', 'ldr-closed'); }
    });
  });
  document.addEventListener('shopify:section:select', function (e) {
    var el = document.querySelector('[data-ldr-landing]');
    if (el && e.detail && el.getAttribute('data-section-id') === e.detail.sectionId && el.__ldrOpen) el.__ldrOpen();
  });

  window.LDRLanding = { init: init };
  var existing = document.querySelector('[data-ldr-landing]');
  if (existing) init(existing);
})();